import { Box, Select, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import { useApiUrl } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import UserRole from "@warriortrading/warriortrading.hermes.common.feathers/enums/userRole";
import { useCallback, useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";

export const RoleBadgesAssignmentsEdit = () => {
    const {
        saveButtonProps,
        register,
        formState: { errors },
        refineCore: { queryResult },
    } = useForm();

    const [id, setId] = useState<any>("");
    const [role, setRole] = useState<any>("");
    const [createdAt, setCreatedAt] = useState("");
    const [updatedAt, setUpdatedAt] = useState("");
    useEffect(() => {
        if (queryResult?.data?.data?.id) {
            setId(queryResult?.data?.data?.id);
        }
        if (queryResult?.data?.data?.role || queryResult?.data?.data?.role === 0) {
            setRole(UserRole.fromValue(queryResult?.data?.data?.role)?.name);
        }
        if (queryResult?.data?.data?.createdAt) {
            setCreatedAt(new Date(queryResult?.data?.data?.createdAt).toLocaleString())
        }
        if (queryResult?.data?.data?.updatedAt) {
            setUpdatedAt(new Date(queryResult?.data?.data?.updatedAt).toLocaleString())
        }
        if (queryResult?.data?.data?.badgeId) {
            setBadgeId(queryResult?.data?.data?.badgeId)
        }
    },[queryResult?.data?.data, queryResult?.data?.data.role]);

    // badgeName
    const apiUrl = useApiUrl();
    const [badgeId, setBadgeId] = useState<string>("");
    const [badgeNameArr, setBadgeNameArr] = useState<{value: string; type: string}[]>([]);
    const badgeNameDataFun = useCallback(() => {
        return dataProvider(apiUrl)
        .getList({resource: "badge"})
        .then((res) => {
            if (res?.data && res?.data.length !== 0) {
                const roleArr = res.data.filter((item: any) => item['badgeType.name'] === "Role");
                const newRoleArr = roleArr.map((item: any) => {
                    return {
                        value: item.id,
                        type: item.name,
                    }
                })
                setBadgeNameArr(newRoleArr);
            }
            return res?.data;
        });
    }, [apiUrl]);

    useEffect(() => {
        badgeNameDataFun();
    },[]);

    return (
        <Edit saveButtonProps={saveButtonProps}>
            <Box
                component="form"
                sx={{ display: "flex", flexDirection: "column" }}
                autoComplete="off"
            >
                <TextField
                    error={!!(errors as any)?.id}
                    helperText={(errors as any)?.id?.message}
                    margin="normal"
                    fullWidth
                    value={id}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Id"
                    name="id"
                    disabled
                />
                <TextField
                    {...register("role", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.role}
                    helperText={(errors as any)?.role?.message}
                    margin="normal"
                    fullWidth
                    value={role}
                    InputLabelProps={{ shrink: true }}
                    label="Role"
                    name="role"
                    disabled
                />
                <TextField
                    error={!!(errors as any)?.createdAt}
                    helperText={(errors as any)?.createdAt?.message}
                    margin="normal"
                    fullWidth
                    value={createdAt}
                    InputLabelProps={{ shrink: true }}
                    label="CreatedAt"
                    name="createdAt"
                    disabled
                />
                <TextField
                    error={!!(errors as any)?.updatedAt}
                    helperText={(errors as any)?.updatedAt?.message}
                    margin="normal"
                    fullWidth
                    value={updatedAt}
                    InputLabelProps={{ shrink: true }}
                    label="UpdatedAt"
                    name="updatedAt"
                    disabled
                />
                <FormControl fullWidth style={{marginTop: "10px", marginBottom: "10px"}}>
                    <InputLabel id="badgeName">BadgeName : </InputLabel>
                    <Select
                        {...register("badgeId", {
                            required: "Choose a badgeId",
                        })}
                        value={badgeId}
                        label="BadgeName"
                        labelId="badgeName"
                        error={badgeId === ""}
                        onChange={(event: SelectChangeEvent) => {
                            setBadgeId(event.target.value as any);
                        }}
                    >
                        {
                        badgeNameArr.map((item) => {
                            return <MenuItem key={item.value} value={item.value}>{item.type}</MenuItem>
                        })
                    }
                    </Select>
                </FormControl>
            </Box>
        </Edit>
    );
};
